module.exports = __webpack_public_path__ + "img/img2.08e404af.jpg";